import { useGetDetailUnitMutation } from '@/modules/maps/services/homeMapService'
import { DetailUnit, UnitsMapType } from '@/modules/maps/types/unitsMapType'
import {
  balloonGreen,
  balloonRed,
  balloonYellow,
} from '@/modules/maps/utils/balloons'
import { useMediaQuery } from '@mui/material'
import { Placemark } from '@pbe/react-yandex-maps'
import React, { FC, useState } from 'react'
import { getIconForUnit } from '@/components/Organisms/Map/Map'

interface Props {
  unit: UnitsMapType
  yamap: any
}

const PlacemarkBalloon: FC<Props> = ({ unit, yamap }) => {
  const isMobile = useMediaQuery('(max-width:767px)')
  const [getDetailUnit, { isLoading, isError, error }] =
    useGetDetailUnitMutation()
  const [unitData, setUnitData] = useState<DetailUnit>({
    id: 0,
    name: '',
    address: '',
    connectionStatus: 3,
    countModules: 0,
    signal: 0,
    smart: false,
    is220v: false,
    type: '',
    voltage: 0,
    typeId: 0,
    state: 1,
    errorMessage: '',
    ultraShortTermForecastId: 0,
  })

  const onLoadData = async (id: number) => {
    try {
      const res = await getDetailUnit(id).unwrap()
      if (Object.values(res).length > 0) {
        setUnitData(() => res)
      }
    } catch (e) {
      console.log(e)
    }
  }

  return (
    <Placemark
      defaultGeometry={unit.coordinates}
      onClick={() => {
        yamap.current.setCenter(
          unit.coordinates,
          yamap.current._zoom > 10 ? yamap.current._zoom : 10,
          {
            checkZoomRange: true,
            duration: 500,
          }
        )
        onLoadData(unit.id)
      }}
      options={{
        iconLayout: 'default#image',
        iconImageHref: getIconForUnit(unit),
        iconImageSize: [40, 40],
        openBalloonOnClick: true,
        hideIconOnBalloonOpen: false,
        balloonOffset: [-70, -34],
        balloonMaxWidth: isMobile ? 257 : 400,
      }}
      properties={{
        id: unit.id,
        balloonContentBody:
          unit.state === 1
            ? balloonGreen(isError, isLoading, unit.isGroup ? unit : unitData)
            : unit.state === 2
              ? balloonYellow(isError, isLoading, unitData)
              : balloonRed(isError, isLoading, unitData),
        clusterCaption: `
                <div style='display: flex; width: 100px; justify-content: space-between; align-items: center; gap: 10px'>
                  <div>${unit.name}</div>
                  <div style='background-color: ${
                    !unit.smart
                      ? '#7d8eff'
                      : unit.status === 1
                        ? 'green'
                        : unit.status === 2
                          ? 'yellow'
                          : unit.status === 3
                            ? 'red'
                            : 'black'
                  }; width: 10px; height: 10px; transform: ${!unit.smart ? 'rotate(45deg)' : 'unset'}; border-radius: ${unit.smart ? '50%' : '0'};'></div>
                </div>`,
        clusterHideIconOnBalloonOpen: false,
        geoObjectHideIconOnBalloonOpen: false,
      }}
    />
  )
}

export default PlacemarkBalloon
